import { z } from "zod";
/**
 * Request schemas for the Team-planet endpoints. Shape validation only —
 * every gameplay rule (Team-building prerequisite, no-active-flights,
 * `manageTeamPlanet` permission, queue limits, affordability) is enforced
 * server-side in `apps/functions/src/teamPlanets.ts`.
 */
export const ConvertToTeamPlanetSchema = z.object({
    /** Which of the leader's OWN planets to convert — chosen from that planet's own page. */
    planetId: z.string().min(1),
});
export const UpgradeTeamPlanetBuildingSchema = z.object({
    buildingType: z.string().min(1),
    /** Surface plot picked for a level 0→1 construct; omitted from the zone list, which lets the server pick the zone's first free plot. */
    plotId: z.string().min(1).optional(),
});
export const CancelTeamPlanetBuildingUpgradeSchema = z.object({
    eventId: z.number().int(),
});
export const QueueTeamPlanetScienceSchema = z.object({
    scienceId: z.string().min(1),
});
export const CancelTeamPlanetScienceSchema = z.object({
    eventId: z.number().int(),
});
export const QueueTeamPlanetShipsSchema = z.object({
    shipId: z.number().int().min(1).max(13),
    quantity: z.number().int().min(1),
});
export const CancelTeamPlanetShipBuildSchema = z.object({
    eventId: z.number().int(),
});
export const QueueTeamPlanetShipUpgradeSchema = z.object({
    shipId: z.number().int().min(1).max(13),
});
export const CancelTeamPlanetShipUpgradeSchema = z.object({
    eventId: z.number().int().positive(),
});
//# sourceMappingURL=teamPlanet.schemas.js.map